import React, { useRef } from "react";
import GoogleMapReact from "google-map-react";
import BeatLoader from "react-spinners/BeatLoader";
import LocationOn from "@material-ui/icons/LocationOn";
import { environment } from "configs/environment";

export const API_KEY = environment.googleMapsApiKey;
const GoogleMap = ({
  location,
  loading,
  setLoading,
  isLocationValid,
  withLeftSeperator = false,
  reservationDetails
}) => {
  const Marker = () => {
    return <LocationOn style={{ fontSize: 40, fill: "#b73b00" }} />;
  };

  const [geo, setGeo] = React.useState({ lat: 40.7128, lng: -74.006 }); // Default to NYC
  const [geocoder, setGeocoder] = React.useState(null);
  const attemptedAddress = useRef(null);

  const handleApiLoaded = ({ maps }) => {
    // Create geocoder instance when Google Maps API is loaded
    setGeocoder(currentGeocoder => currentGeocoder || new maps.Geocoder());
  };

  const address =
    location && isLocationValid
      ? `${location.settings.address.address1}, ${location.settings.address.city}, ${location.settings.address.state} ${location.settings.address.postal}`
      : "";
  const showLoadingOverlay = loading || (!!address && !geocoder);

  React.useEffect(() => {
    if (!address || !geocoder || attemptedAddress.current === address) {
      return;
    }

    attemptedAddress.current = address;
    let cancelled = false;
    setLoading(true);

    try {
      geocoder.geocode({ address }, (results, status) => {
        if (cancelled) {
          return;
        }

        if (status === "OK" && results[0]) {
          const geoLocation = results[0].geometry.location;
          setGeo({
            lat: geoLocation.lat(),
            lng: geoLocation.lng()
          });
        } else {
          console.error("Geocoding failed:", status);
        }
        setLoading(false);
      });
    } catch (e) {
      console.error("Geocoding error:", e);
      setLoading(false);
    }

    return () => {
      cancelled = true;
    };
  }, [address, geocoder, setLoading]);

  return (
    location &&
    isLocationValid && (
      <>
        {withLeftSeperator && <div className="self-reservations__separate-line" />}
        <div className="self-reservations__address">
          <div className="self-reservations__title">
            {location.name} - {location.settings.address.city}
          </div>
          <div className="self-reservations__title address small">
            {location.settings.address.address1}, {location.settings.address.city}, {location.settings.address.state}
          </div>
          {reservationDetails}
          <div className="self-reservations__map" style={{ position: "relative" }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: API_KEY }}
              center={geo}
              defaultZoom={15}
              onGoogleApiLoaded={handleApiLoaded}
              yesIWantToUseGoogleMapApiInternals={true}
            >
              <Marker {...geo} />
            </GoogleMapReact>
            {showLoadingOverlay && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(255, 255, 255, 0.75)"
                }}
              >
                <BeatLoader margin={2.5} size={20} color={"#5472D3"} />
              </div>
            )}
          </div>
        </div>
      </>
    )
  );
};

export default GoogleMap;
